export default {
  namespaced: true,
  state: {
    validFor: 1000 * 60 * 10, // 10 minutes
    items: {}
  },

  getters: {
    get: (state, getters) => key => {
      if (getters.isValid(key)) {
        return state.items[key].data
      }
    },

    isValid: state => key => {
      const item = state.items[key]
      const timestamp = Date.now()

      if (
        item &&
        state.validFor > (timestamp - item.timestamp)
      ) {
        return true
      }

      return false
    }
  },

  mutations: {
    set: (state, payload) => {
      const key = payload.key

      // Cache item can be used to stop an ajax request without storing the data on this object
      state.items[key] = {
        timestamp: Date.now(),
        data: payload.data ? payload.data : null
      }
    }
  }
}
